/* eslint-disable no-undef */
$('.reviews-io-grovia__wrapper form[action="/cart/add"]').submit(function (e) {
  e.preventDefault();

  //? Do we really need this?
  const btn = document.querySelector('.reviews-io-grovia__wrapper .ProductForm__AddToCart');
  if (btn) {
    btn.setAttribute('disabled', 'disabled');
  }

  $.ajax({
    url: '/cart/add',
    type: 'post',
    data: $('.reviews-io-grovia__wrapper form[action="/cart/add"]').serialize(),
    success: function () {
      const str = $('.reviews-io-grovia__wrapper form[action="/cart/add"]').serialize();
      const vals = str.split('&');
      let variantID = '';
      let quantity = '';
      for (let i = 0; i < vals.length; i++) {
        if (vals[i].includes('id')) {
          varTmp = vals[i].split('=');
          variantID = varTmp[1];
        } else if (vals[i].includes('quantity')) {
          quantityTmp = vals[i].split('=');
          quantity = quantityTmp[1];
        }
      }

      document.documentElement.dispatchEvent(
        new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variantID,
            quantity: quantity,
          },
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', {
          bubbles: true,
        })
      );
    },
  });

  //? Do we really need this?
  if (btn) {
    setTimeout(function () {
      btn.removeAttribute('disabled');
    }, 1000);
  }
});

/*
| [x] Uncheck prev, check new
| [x] Update Selector
| [x] Update Price
| [x] Update Available 
*/

const reviewsWrapper = document.querySelector('.reviews-io-grovia__wrapper');

$('.reviews-io-grovia__wrapper .ProductForm__Variants .HorizontalList__Item').each(
  (index, elem) => {
    elem.addEventListener('click', (e) => {
      e.preventDefault();

      const prevChecked = Array.from(elem.parentElement.childNodes).find(
        (elem) => elem.firstElementChild.getAttribute('checked') == 'checked'
      );
      const prevSelected = Array.from(
        document.querySelectorAll('.reviews-io-grovia__wrapper .ProductForm__Option.no-js option')
      ).find((elem) => elem.hasAttribute('selected'));

      if (prevChecked != elem) {
        // Uncheck prev, check new
        prevChecked.firstElementChild.removeAttribute('checked');
        elem.firstElementChild.setAttribute('checked', 'checked');

        // Update Option
        prevSelected.removeAttribute('selected');

        const option = reviewsWrapper.querySelectorAll('.ProductForm__Option.no-js option')[index];
        option.setAttribute('selected', 'selected');

        const variant = window.currentProduct.variants.find((elem) => elem.id == option.value);

        // Update Selector
        document.querySelector('.reviews-io-grovia__wrapper #result').innerText = elem.innerText;

        // Update Price
        const price = variant.price / 100;
        if (reviewsWrapper.querySelector('.Price--compareAt') != null) {
          reviewsWrapper.querySelector('ProductMeta__Price Price Price--highlight').innerText =
            price.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
        } else {
          reviewsWrapper.querySelector('.ProductMeta__Price').innerText = price.toLocaleString(
            'de-DE',
            { style: 'currency', currency: 'EUR' }
          );
        }
        const atcBtn = reviewsWrapper.querySelector('button.ProductForm__AddToCart ');
        const shippingInfoContainer = reviewsWrapper.querySelector('.ShippingInfo');

        // Update ATC
        if (variant.available) {
          atcBtn.removeAttribute('disabled');
          atcBtn.setAttribute('data-action', 'add-to-cart');
          atcBtn.innerHTML = '<span>' + window.languages.productFormAddToCart + '</span>';

          atcBtn.classList.remove('Button--sold-out');
          shippingInfoContainer.classList.remove('-IsUnavailable');
        } else {
          atcBtn.setAttribute('disabled', 'disabled');
          atcBtn.removeAttribute('data-action');
          atcBtn.innerHTML = window.languages.productFormSoldOut;

          atcBtn.classList.add('Button--sold-out');
          shippingInfoContainer.classList.add('-IsUnavailable');
        }

        // Update URL
        const params = new URLSearchParams(window.location.search);
        params.set('variant', variant.id);
        history.replaceState(null, null, '?' + params.toString());
      }
    });
  }
);

const productWrapper = document.querySelector('.Product__Wrapper');
$('.Product__Wrapper .ProductForm__Variants .HorizontalList__Item input').each((index, input) => {
  input.addEventListener('click', (e) => {
    //e.preventDefault();

    const elem = input.parentNode;

    const prevChecked = Array.from(elem.parentElement.childNodes).find(
      (elem) => elem.firstElementChild.getAttribute('checked') == 'checked'
    );
    const prevSelected = Array.from(
      document.querySelectorAll('.Product__Wrapper .ProductForm__Option.no-js option')
    ).find((elem) => elem.hasAttribute('selected'));

    if (prevChecked != elem) {
      // Uncheck prev, check new

      prevChecked.firstElementChild.removeAttribute('checked');
      elem.firstElementChild.setAttribute('checked', 'checked');
      // Update Option
      prevSelected.removeAttribute('selected');

      const option = productWrapper.querySelectorAll('.ProductForm__Option.no-js option')[index];
      option.setAttribute('selected', 'selected');

      const variant = window.currentProduct.variants.find((elem) => elem.id == option.value);
      // Update Selector
      document.querySelector('#result').textContent = elem.textContent.trim();

      const price = variant.price / 100;
      if (productWrapper.querySelector('.Price--compareAt') != null) {
        productWrapper.querySelector('ProductMeta__Price Price Price--highlight').innerText =
          price.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
      } else {
        productWrapper.querySelector('.ProductMeta__Price').innerText = price.toLocaleString(
          'de-DE',
          { style: 'currency', currency: 'EUR' }
        );
      }
    }
  });
});
